import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private footerCache$: Observable<any> | null = null;

  constructor(private apiService: ApiService) {}

  getFooterMenus(): Observable<any> {
    if (!this.footerCache$) {
      this.footerCache$ = this.apiService
        .get('customer/footer/menus-data')
        .pipe(shareReplay(1));
    }
    return this.footerCache$;
  }
}
